import Templates from '@/widgets/index';
import useSWR from 'swr';
const PagegrowlerList = (props) => {
    const { widget, url, clear = false, fallbackData } = props

    const fetcher = (...args) => fetch(...args).then(res => res.json())

    const { data, error, isLoading } = useSWR(
        `/api/pagegrowlerList/${url}/${clear}`,
        fetcher,
        fallbackData ? { fallbackData } : undefined
    );
// console.log(`/api/pagegrowlerList/${url}/${clear}`,data);
    return (
        <>
            {
                data?.data?.widgets && data?.data.widgets.map(el => {

                    const nameTemplate = !el.template ? el.innerBoxes?.[0].subItems?.[0].template : el.template;
                    const TemplateWidget = Templates[!widget ? nameTemplate : widget];
                    const paramsProps = !el.params ? el?.innerBoxes?.[0].subItems?.[0].params : el.params;
                    
                    return <TemplateWidget key={el.id} aditionalData={props} {...paramsProps}  />

                })
            }
        </>
    )
}

export default PagegrowlerList